<template>
  <div
    :class="classes"
    :style="styles"
  >
    <slot />
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'cTitle',
  props: {
    color: {
      type: String,
      default: '#000',
      description: 'hexadecimal color (#FFF)'
    },
    size: {
      type: String,
      default: 'lg',
      description: '(h1 / h2 / h3 / sm / md / lg / xl)'
    },
    weight: {
      type: String,
      default: 'lighter',
      description: '(100-800 / bolder / lighter / normal)'
    },
    align: {
      type: String,
      default: 'left'
    }
  },
  setup(props) {
    const classes = computed(() => [
      'c-title',
      `c-title--${props.size}`,
      `c-title--${props.weight}`,
      `c-title--${props.align}`
    ])
    const styles = computed(() => ({
      color: props.color
    }))
    return {
      classes,
      styles
    }
  }
}
</script>

<style lang="scss" scoped>

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}

.c-title {
  display: flex;

  &--h1 {
    @include h1();
  }

  &--h2 {
    @include h2();
  }

  &--h3 {
    @include h3();
  }

  &--xs {
    font-size: 28px;
    line-height: 28px;

    @media (min-width: 768px) {
      font-size: 32px;
      line-height: 32px;
    }

    @media (min-width: 992px) {
      font-size: 36px;
      line-height: 36px;
    }

    @media (min-width: 1200px) {
      font-size: 40px;
      line-height: 40px;
    }
  }

  &--sm {
    font-size: 32px;
    line-height: 32px;

    @media (min-width: 768px) {
      font-size: 36px;
      line-height: 36px;
    }

    @media (min-width: 992px) {
      font-size: 40px;
      line-height: 40px;
    }

    @media (min-width: 1200px) {
      font-size: 44px;
      line-height: 44px;
    }
  }

  &--md {
    font-size: 36px;
    line-height: 36px;

    @media (min-width: 768px) {
      font-size: 40px;
      line-height: 40px;
    }

    @media (min-width: 992px) {
      font-size: 44px;
      line-height: 44px;
    }

    @media (min-width: 1200px) {
      font-size: 48px;
      line-height: 48px;
    }
  }

  &--lg {
    font-size: 44px;
    line-height: 44px;

    @media (min-width: 768px) {
      font-size: 48px;
      line-height: 48px;
    }

    @media (min-width: 992px) {
      font-size: 52px;
      line-height: 52px;
    }

    @media (min-width: 1200px) {
      font-size: 56px;
      line-height: 56px;
    }
  }

  &--xl {
    font-size: 48px;
    line-height: 48px;

    @media (min-width: 768px) {
      font-size: 52px;
      line-height: 52px;
    }

    @media (min-width: 992px) {
      font-size: 56px;
      line-height: 56px;
    }

    @media (min-width: 1200px) {
      font-size: 60px;
      line-height: 60px;
    }
  }

  @include textAlign();

  @include weight();
}
</style>
